export function validWallet(str) {
  return str && str.length === 42 && str.match(/^0x[a-fA-F0-9]{40}$/);
}
